/** Registry key for the VhModuleConfig entity. */
export const MODULE_CONFIG = 'VhModuleConfig';
//# sourceMappingURL=moduleConfig.js.map